import ServiceDetailPage from "@/components/ServiceDetailPage";

const Courses = () => <ServiceDetailPage pageKey="courses" />;

export default Courses;
